/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken, selectCurrentUserM11Use } from "../../slices/currentUser/currentUserSlice";
import {
  m11ReportContainerFoiChanged, m11ReportContainerResourceChanged,
  m11ReportSection08FoiChanged, m11ReportSection08ResourceChanged, selectM11ReportContainerFoi,
  selectM11ReportContainerResource, selectM11ReportSection08Foi, selectM11ReportSection08Resource,
  selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import jsonEquals from "../../functions/jsonEquals";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import TextDivEntry from "./TextDivEntry";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const saveTrialAssessmentsChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
  section08State, setAlertModalState, setStartingSection08State) => {

  let changesStates = {
    section08State: section08State
  };
  let response = await saveM11Changes(apiToken, 28, m11ResearchStudyFoi, changesStates);
  if (response?.success) {
    if (response.m11ReportContainerResource) {
      dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
    }
    if (response.m11ReportSection08Resource) {
      dispatch(m11ReportSection08ResourceChanged(response.m11ReportSection08Resource));
    }
    setStartingSection08State(JSON.parse(JSON.stringify(section08State)));
  } else {
    if (response.error) {
      alert(response.error);
    }
  }
};

const M11Step028TrialAssessmentsPart2 = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

  const dispatch = useDispatch();
  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11User = useSelector(selectCurrentUserM11Use);
  const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
  const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
  const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
  const m11ReportSection08Foi = useSelector(selectM11ReportSection08Foi);
  const m11ReportSection08Resource = useSelector(selectM11ReportSection08Resource);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [section08State, setSection08State] = useState({
    "section844Status": "empty", "section844Xhtml": "",
    "section841Status": "empty", "section841Xhtml": "",
    "section842Status": "empty", "section842Xhtml": "",
    "section843Status": "empty", "section843Xhtml": "",
    "section845Status": "empty", "section845Xhtml": "",
    "section846Status": "empty", "section846Xhtml": "",
    "section84Status": "empty", "section84Xhtml": ""
  });
  const [startingSection08State, setStartingSection08State] = useState({
    "section844Status": "empty", "section844Xhtml": "",
    "section841Status": "empty", "section841Xhtml": "",
    "section842Status": "empty", "section842Xhtml": "",
    "section843Status": "empty", "section843Xhtml": "",
    "section845Status": "empty", "section845Xhtml": "",
    "section846Status": "empty", "section846Xhtml": "",
    "section84Status": "empty", "section84Xhtml": ""
  });
  const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);

  useImperativeHandle(ref, () => ({
    unsavedChanges: (m11ResearchStudyResource && !jsonEquals(section08State, startingSection08State)),
    async saveAllChanges() {
      await saveTrialAssessmentsChanges(dispatch, apiToken, m11ResearchStudyFoi,
        section08State, setAlertModalState, setStartingSection08State);
    }
  }));

  useEffect(() => {
    if (m11ResearchStudyResource?.id) {
      let m11ReportFoi = "";
      if (m11ResearchStudyResource.relatesTo?.length > 0) {
        for (let relatesTo of m11ResearchStudyResource.relatesTo) {
          if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
            relatesTo.targetReference) {
            m11ReportFoi = getIdFromReference(relatesTo.targetReference);
          }
        }
      }
      if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
        dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ResearchStudyResource]);

  useEffect(() => {
    if (initialCalculationNeeded === true) {
      let startingData = {
        "section844Status": "empty", "section844Xhtml": "",
        "section841Status": "empty", "section841Xhtml": "",
        "section842Status": "empty", "section842Xhtml": "",
        "section843Status": "empty", "section843Xhtml": "",
        "section845Status": "empty", "section845Xhtml": "",
        "section846Status": "empty", "section846Xhtml": "",
        "section84Status": "empty", "section84Xhtml": "",
        "loaded": true
      };
      setSection08State(startingData);
      setStartingSection08State(startingData);
    }
  }, [initialCalculationNeeded]);

  useEffect(() => {
    if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
      loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
    }
  }, [m11ReportContainerFoi]);

  useEffect(() => {
    if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
      if (m11ReportContainerResource.section?.[8]?.entry?.length) {
        let m11ReportSection008Foi = getIdFromReference(m11ReportContainerResource.section[8].entry[0]);
        if (m11ReportSection008Foi && !isNaN(m11ReportSection008Foi) && m11ReportSection008Foi !== m11ReportSection08Foi) {
          dispatch(m11ReportSection08FoiChanged(m11ReportSection008Foi));
        } else {
          setInitialCalculationNeeded(true);
        }
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ReportContainerResource]);

  useEffect(() => {
    if (m11ReportSection08Foi && !isNaN(m11ReportSection08Foi)) {
      loadResource(m11ReportSection08Foi, "M11ReportSection08", apiToken, dispatch);
    }
  }, [m11ReportSection08Foi]);

  useEffect(() => {
    if (m11ReportSection08Resource && Object.keys(m11ReportSection08Resource).length > 0) {
      let startingData = {
        "section844Status": "empty", "section844Xhtml": "",
        "section841Status": "empty", "section841Xhtml": "",
        "section842Status": "empty", "section842Xhtml": "",
        "section843Status": "empty", "section843Xhtml": "",
        "section845Status": "empty", "section845Xhtml": "",
        "section846Status": "empty", "section846Xhtml": "",
        "section84Status": "empty", "section84Xhtml": "",
        "loaded": true
      };
      if (m11ReportSection08Resource.section?.[0]?.section?.length > 0) {
        if (m11ReportSection08Resource.section[0].section[3]?.text?.div &&
          m11ReportSection08Resource.section[0].section[3].text.status !== "empty") {
          startingData.section84Status = m11ReportSection08Resource.section[0].section[3].text.status;
          startingData.section84Xhtml = m11ReportSection08Resource.section[0].section[3].text.div;
        }
        if (m11ReportSection08Resource.section[0].section[3]?.section?.length > 0) {
          if (m11ReportSection08Resource.section[0].section[3].section[0]?.text?.div &&
            m11ReportSection08Resource.section[0].section[3].section[0].text.status !== "empty") {
            startingData.section841Status = m11ReportSection08Resource.section[0].section[3].section[0].text.status;
            startingData.section841Xhtml = m11ReportSection08Resource.section[0].section[3].section[0].text.div;
          }
          if (m11ReportSection08Resource.section[0].section[3].section[1]?.text?.div &&
            m11ReportSection08Resource.section[0].section[3].section[1].text.status !== "empty") {
            startingData.section842Status = m11ReportSection08Resource.section[0].section[3].section[1].text.status;
            startingData.section842Xhtml = m11ReportSection08Resource.section[0].section[3].section[1].text.div;
          }
          if (m11ReportSection08Resource.section[0].section[3].section[2]?.text?.div &&
            m11ReportSection08Resource.section[0].section[3].section[2].text.status !== "empty") {
            startingData.section843Status = m11ReportSection08Resource.section[0].section[3].section[2].text.status;
            startingData.section843Xhtml = m11ReportSection08Resource.section[0].section[3].section[2].text.div;
          }
          if (m11ReportSection08Resource.section[0].section[3].section[3]?.text?.div &&
            m11ReportSection08Resource.section[0].section[3].section[3].text.status !== "empty") {
            startingData.section844Status = m11ReportSection08Resource.section[0].section[3].section[3].text.status;
            startingData.section844Xhtml = m11ReportSection08Resource.section[0].section[3].section[3].text.div;
          }
          if (m11ReportSection08Resource.section[0].section[3].section[4]?.text?.div &&
            m11ReportSection08Resource.section[0].section[3].section[4].text.status !== "empty") {
            startingData.section845Status = m11ReportSection08Resource.section[0].section[3].section[4].text.status;
            startingData.section845Xhtml = m11ReportSection08Resource.section[0].section[3].section[4].text.div;
          }
          if (m11ReportSection08Resource.section[0].section[3].section[5]?.text?.div &&
            m11ReportSection08Resource.section[0].section[3].section[5].text.status !== "empty") {
            startingData.section846Status = m11ReportSection08Resource.section[0].section[3].section[5].text.status;
            startingData.section846Xhtml = m11ReportSection08Resource.section[0].section[3].section[5].text.div;
          }
        }
        setSection08State(startingData);
        setStartingSection08State(startingData);
      } else {
        setInitialCalculationNeeded(true);
      }
    }
  }, [m11ReportSection08Resource]);

  return <div>
    <h3>Complete Section 8.4 Safety Assessments and Procedures</h3>
    {!(m11ReportSection08Resource?.id || m11ReportContainerResource?.id) &&
      <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
    }
    {m11User === "sample" ?
      <div style={{ outline: "1px solid #000000", padding: "6px", width: "fit-content" }}>
        <h2>You are using the M11 Report Authoring Tool (Test Drive Version).</h2>
        <p style={{ color: "red" }}>Step 28 (Complete Section 8.4 Safety Assessments and Procedures) is not included in the M11 Report Authoring Tool (Test Drive Version).</p>
        <p>Subscribe to the M11 Report Authoring Tool (Professional Version) for complete functionality.</p>
      </div>
      :
      <>
        {section08State.loaded && <>
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 8.4 Safety Assessments and Procedures summary as needed.</h4>
          <TextDivEntry elementName="section84Xhtml"
            startingValue={section08State.section84Xhtml}
            setResourceState={setSection08State} />
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 8.4.1 Physical Examination as needed.</h4>
          <TextDivEntry elementName="section841Xhtml"
            startingValue={section08State.section841Xhtml}
            setResourceState={setSection08State} />
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 8.4.2 Vital Signs as needed.</h4>
          <TextDivEntry elementName="section842Xhtml"
            startingValue={section08State.section842Xhtml}
            setResourceState={setSection08State} />
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 8.4.3 Electrocardiograms as needed.</h4>
          <TextDivEntry elementName="section843Xhtml"
            startingValue={section08State.section843Xhtml}
            setResourceState={setSection08State} />
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 8.4.4 Clinical Laboratory Assessments summary as needed.</h4>
          <TextDivEntry elementName="section844Xhtml"
            startingValue={section08State.section844Xhtml}
            setResourceState={setSection08State} />
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 8.4.5 Pregnancy Testing summary as needed.</h4>
          <TextDivEntry elementName="section845Xhtml"
            startingValue={section08State.section845Xhtml}
            setResourceState={setSection08State} />
          <h4 style={{ marginBottom: "0px" }}>Revise the Section 8.4.6 Suicidal Ideation and Behaviour Risk Monitoring summary as needed.</h4>
          <TextDivEntry elementName="section846Xhtml"
            startingValue={section08State.section846Xhtml}
            setResourceState={setSection08State} />
        </>}
      </>
    }
  </div >
});

const M11Step028TrialAssessmentsPart2HelperText = <div>
  <h3>Complete Section 8.4 Safety Assessments and Procedures</h3>
  <div style={{ textAlign: "left" }}>
    <p>Enter data for Section 8.4 Safety Assessments and Procedures.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Describe safety assessments and procedures utilising the following subsections as applicable.</p>
      <p>Identify any noninvestigator party involved in the evaluation of laboratory or other safety assessments (e.g., sponsor or external Independent Data Monitoring Committee; cross reference Section 11.4 Committees for details as applicable).</p>
      <p>Include guidelines for the medical management of relevant laboratory or other safety assessment abnormalities.</p>
    </div>
    <p>If applicable, enter data for Section 8.4.1 Physical Examination.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Include any specific instructions for the collection and interpretation of physical examinations.</p>
    </div>
    <p>If applicable, enter data for Section 8.4.2 Vital Signs.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Include any specific instructions for the collection and interpretation of vital signs.</p>
    </div>
    <p>If applicable, enter data for Section 8.4.3 Electrocardiograms.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Include any specific instructions for the collection, interpretation, and archiving of ECGs.</p>
    </div>
    <p>If applicable, enter data for Section 8.4.4 Clinical Laboratory Assessments.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Describe any specific instructions for the collection and interpretation of clinical laboratory assessments, including:</p>
      <div style={{ marginLeft: "24px" }} >
        <p>•	type of laboratory (central/local/hybrid)</p>
        <p>•	acceptability of additional tests deemed necessary by the investigator or local regulations</p>
        <p>•	instructions for situations in which central laboratory results are not available in time for trial intervention and/or response evaluation, or in the event of a severe disruption (e.g., a pandemic or natural disaster)</p>
        <p>•	treatment algorithms for results out of normal range</p>
        <p>•	cross reference Section 12.1 Clinical Laboratory Tests for laboratory assessment panels</p>
      </div>
    </div>
    <p>If applicable, enter data for Section 8.4.5 Pregnancy Testing.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>Include any specific instructions for the collection and interpretation of pregnancy testing.</p>
    </div>
    <p>If applicable, enter data for Section 8.4.6 Suicidal Ideation and Behaviour Risk Monitoring.</p>
    <div style={{ marginLeft: "24px" }} >
      <p>If the trial meets any of the criteria requiring suicidal ideation and behaviour risk monitoring by the guidance/guideline in each region, include justification for the need for suicidal ideation and behaviour risk monitoring in the study and add any specific instructions for the collection and interpretation of the assessment. In case this is an AESI in the study, justification should also be provided in Section 9.2.4 Adverse Events of Special Interest.</p>
    </div>
    <p>Click the 'Save All Changes' button.</p>
  </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step028TrialAssessmentsPart21ValidationCheck = ({ }) => {

  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [validationCheckState, setValidationCheckState] = useState({});

  useEffect(() => {
    if (m11ResearchStudyFoi) {
      validateStep(apiToken, 28, m11ResearchStudyFoi,
        setValidationCheckState)
    }
  }, [m11ResearchStudyFoi]);

  return <div>{validationCheckState?.success && <div>
    <h4>Step 28 (Complete Section 8.4 Safety Assessments and Procedures) {validationCheckState.step28numberOfChecks} issues checked. {validationCheckState.step28numberPassed} passed. {validationCheckState.step28numberFailed} failed.</h4>
    <p>Section 8.4 heading is 'Safety Assessments and Procedures': {validationCheckState.resultCheckSection84Heading}</p>
    <p>Section 8.4 Safety Assessments and Procedures has content: {validationCheckState.resultCheckSection84Content}</p>
    <p>If present, Section 8.4.1 heading is 'Physical Examination': {validationCheckState.resultCheckSection841Heading}</p>
    <p>If present, Section 8.4.1 Physical Examination has content: {validationCheckState.resultCheckSection841Content}</p>
    <p>If present, Section 8.4.2 heading is 'Vital Signs': {validationCheckState.resultCheckSection842Heading}</p>
    <p>If present, Section 8.4.2 Vital Signs has content: {validationCheckState.resultCheckSection842Content}</p>
    <p>If present, Section 8.4.3 heading is 'Electrocardiograms': {validationCheckState.resultCheckSection843Heading}</p>
    <p>If present, Section 8.4.3 Electrocardiograms has content: {validationCheckState.resultCheckSection843Content}</p>
    <p>If present, Section 8.4.4 heading is 'Clinical Laboratory Assessments': {validationCheckState.resultCheckSection844Heading}</p>
    <p>If present, Section 8.4.4 Clinical Laboratory Assessments has content: {validationCheckState.resultCheckSection844Content}</p>
    <p>If present, Section 8.4.5 heading is 'Pregnancy Testing': {validationCheckState.resultCheckSection845Heading}</p>
    <p>If present, Section 8.4.5 Pregnancy Testing has content: {validationCheckState.resultCheckSection845Content}</p>
    <p>If present, Section 8.4.6 heading is 'Suicidal Ideation and Behaviour Risk Monitoring': {validationCheckState.resultCheckSection846Heading}</p>
    <p>If present, Section 8.4.6 Suicidal Ideation and Behaviour Risk Monitoring has content: {validationCheckState.resultCheckSection846Content}</p>
  </div>}  </div>
}

export default M11Step028TrialAssessmentsPart2;
export { M11Step028TrialAssessmentsPart2HelperText, M11Step028TrialAssessmentsPart21ValidationCheck };